'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _circularProgress = require('material-ui/lib/circular-progress');

var _circularProgress2 = _interopRequireDefault(_circularProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BinaryIframe = function (_Component) {
  _inherits(BinaryIframe, _Component);

  function BinaryIframe(props) {
    _classCallCheck(this, BinaryIframe);

    // const {id} = this.props;
    var _this = _possibleConstructorReturn(this, (BinaryIframe.__proto__ || Object.getPrototypeOf(BinaryIframe)).call(this, props));

    _this.state = {
      loading: true
    };
    _this.onLoad = function () {
      _this.removeOnLoadEvent();
      if (_this.props.onLoad) {
        setTimeout(function () {
          _this.props.onLoad();
        }, 2000);
      }
      // if (id && document.getElementById(id)) { document.getElementById(id).src = document.getElementById(id).src; }
      _this.displayIframeInlineBlock();
      _this.setState({
        loading: false
      });
    };
    return _this;
  }

  _createClass(BinaryIframe, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initialLoad();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.initialLoad();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.src !== nextProps.src || this.props.id !== nextProps.id && this.props.src !== nextProps.src || this.state.loading && !nextState.loading;
    }
  }, {
    key: 'initialLoad',
    value: function initialLoad() {
      var _props = this.props,
          alwaysShow = _props.alwaysShow,
          delayShowTime = _props.delayShowTime;

      if (!alwaysShow) {
        _reactDom2.default.findDOMNode(this.refs.iframe).style.display = 'none';
      }
      _reactDom2.default.findDOMNode(this.refs.iframe).addEventListener('load', this.onLoad);
      this.displayAfterCertainTime(delayShowTime);
    }
  }, {
    key: 'removeOnLoadEvent',
    value: function removeOnLoadEvent() {
      _reactDom2.default.findDOMNode(this.refs.iframe).removeEventListener('load', this.onLoad);
    }
  }, {
    key: 'displayAfterCertainTime',
    value: function displayAfterCertainTime(millisecond) {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.props.style.display !== 'none' && _reactDom2.default.findDOMNode(_this2.refs.iframe) !== null) {
          _reactDom2.default.findDOMNode(_this2.refs.iframe).style.display = 'inline-block';
        }
      }, millisecond);
    }
  }, {
    key: 'displayIframeInlineBlock',
    value: function displayIframeInlineBlock() {
      if (typeof this.props.style.display === 'undefined') {
        _reactDom2.default.findDOMNode(this.refs.iframe).style.display = 'inline-block';
      } else {
        if (this.props.style.display !== 'none') {
          _reactDom2.default.findDOMNode(this.refs.iframe).style.display = 'inline-block';
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./BinaryIframe.scss');
      return _react2.default.createElement(
        'div',
        null,
        this.state.loading && _react2.default.createElement(
          'div',
          { className: styles.binary_iframe_spinner },
          _react2.default.createElement(_circularProgress2.default, { size: 1, color: '#FF7052' })
        ),
        _react2.default.createElement('iframe', _extends({ title: this.props.id, className: styles.binary_iframe, ref: 'iframe' }, this.props))
      );
    }
  }]);

  return BinaryIframe;
}(_react.Component);

BinaryIframe.propTypes = {
  id: _propTypes2.default.string,
  src: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.object,
  alwaysShow: _propTypes2.default.bool,
  delayShowTime: _propTypes2.default.number,
  onLoad: _propTypes2.default.func
};
BinaryIframe.defaultProps = {
  alwaysShow: true,
  delayShowTime: 3000,
  style: {},
  id: Math.random()
};
exports.default = BinaryIframe;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryIframe/BinaryIframe.js
// module id = 2154
// module chunks = 1